import { NavLink } from 'react-router-dom';
import { ReactComponent as Icon } from '../../assets/icon-cancel.svg';
import {
  motion,
  useAnimation,
  AnimatePresence,
  easeInOut,
} from 'framer-motion';
import { useState } from 'react';
import styled from 'styled-components';

const DetailsComponent = ({ children }) => {
  const [isHovered, setIsHovered] = useState(false);
  const controls = useAnimation();

  const buttonVariants = {
    hovered: { scale: 1.2, transition: { duration: 0.5, ease: easeInOut } },
    notHovered: { scale: 1, transition: { duration: 0.5, ease: easeInOut } },
  };

  const siblingDivVariants = {
    hovered: { y: 20, transition: { duration: 0.5, ease: easeInOut } },
    notHovered: { y: 0, transition: { duration: 0.5, ease: easeInOut } },
  };

  const handleHover = () => {
    setIsHovered(() => !isHovered);
    controls.start(isHovered ? 'notHovered' : 'hovered');
  };

  return (
    <Wrapper
      as={motion.div}
      initial={{ y: 30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: 'spring', duration: 1.5, delay: 0.25, bounce: 0.5 }}
    >
      <NavLink to='/'>
        <Button
          as={motion.button}
          onMouseEnter={handleHover}
          onMouseLeave={handleHover}
          variants={buttonVariants}
          animate={controls}
          whileHover='hovered'
          whileTap='notHovered'
        >
          <CancelIcon />
        </Button>
      </NavLink>
      <AnimatePresence>
        <Content
          as={motion.div}
          initial='notHovered'
          animate={controls}
          exit='notHovered'
          variants={siblingDivVariants}
        >
          {children}
        </Content>
      </AnimatePresence>
    </Wrapper>
  );
};

const CancelIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  color: red;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  flex-direction: column;
  padding: 40px 0;
  gap: 48px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 60px;
  gap: 16px;

  @media (max-width: 500px) {
    flex-direction: column;
    padding: 0 24px;
  }
`;

const Button = styled.button`
  width: 46px;
  height: 46px;
  border: none;
  border-radius: 23px;
  background-color: ${({ theme }) => theme.tileBackground};
  align-items: center;
  justify-content: center;
  display: flex;
`;

export default DetailsComponent;
